<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Province</h2>
    </div>
  </div>
  <CriteresRechercheProvinces @rechercher="rechercher"/>
  <ResultatRechercheProvinces :provinces="provinces" :isRechercheDataLoading="isRechercheDataLoading" @removeProvinceFromList="removeProvinceFromList"/>
</template>

<script>
import CriteresRechercheProvinces
  from '../../../../components/pilotage/ClassementDesVilles/Province/CriteresRechercheProvinces.vue'
import ResultatRechercheProvinces
  from '../../../../components/pilotage/ClassementDesVilles/Province/ResultatRechercheProvinces.vue'

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    CriteresRechercheProvinces,
    ResultatRechercheProvinces
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Province");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('adresse/obtenirLibellesAction');
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      provinces: [],
      isRechercheDataLoading: false
    }
  },
  methods: {
    rechercher(libelleRecherche) {

      this.provinces = [];
      this.isRechercheDataLoading = true;

      this.$store.dispatch("pilotage/rechercherTableValeurAvecAscAction", libelleRecherche).then((res) => {
        res.data.libelles.forEach((currentPays) => {
          currentPays.tableValeur.libelles.forEach((currentProvince) => {
            let currentProvinceComplete = currentProvince;
            currentProvinceComplete.clePays = currentPays.tableValeur.cle;
            currentProvinceComplete.pays = currentPays.tableValeur.description;
            this.provinces.push(currentProvinceComplete)
          })
        })
        this.isRechercheDataLoading = false;
      });
    },
    removeProvinceFromList(province) {
      this.provinces = this.provinces.filter(current => (current.cle != province.cle))
    }
  }
}
</script>
